// extracted by mini-css-extract-plugin
export default {"Box":"EditSponsor_Box__GzGZe","SponsorBox":"EditSponsor_SponsorBox__p8lUF","BoxInnerHeader":"EditSponsor_BoxInnerHeader__Hoo6T","BoxHeader":"EditSponsor_BoxHeader__xlM8O"};